export function getNode(doc, id) {
    return doc.nodes[id];
}
/**
 * Looks a node up or throws.
 *
 * For call sites that have already established the node exists — after a `has` check, or on the
 * root. A missing node there is a corrupted document, not a recoverable condition, and returning
 * `undefined` would only push the crash somewhere less informative.
 */
export function requireNode(doc, id) {
    const node = doc.nodes[id];
    if (node === undefined)
        throw new Error(`node not found in map ${doc.map.id}: ${id}`);
    return node;
}
export function getRoot(doc) {
    return requireNode(doc, doc.map.rootNodeId);
}
export function getEdge(doc, id) {
    return doc.edges[id];
}
export function nodeCount(doc) {
    return Object.keys(doc.nodes).length;
}
export function edgeCount(doc) {
    return Object.keys(doc.edges).length;
}
export function allNodes(doc) {
    return Object.values(doc.nodes);
}
export function allEdges(doc) {
    return Object.values(doc.edges);
}
/** Every edge with at least one end on `nodeId`, in either direction. */
export function edgesTouching(doc, nodeId) {
    return allEdges(doc).filter((edge) => edge.sourceNodeId === nodeId || edge.targetNodeId === nodeId);
}
export function belongsToMap(doc, mapId) {
    return doc.map.id === mapId;
}
//# sourceMappingURL=document.js.map